import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Overlay } from '../../App/components/Overlay';
import {
  closeClassroomModal,
  closeKeyboardShortcutModal,
  closePreferences,
  closeShareModal,
  hideErrorModal
} from '../actions/ide';
import ErrorModal from './ErrorModal';
import Feedback from './Feedback';
import KeyboardShortcutModal from './KeyboardShortcutModal';
import NewFileModal from './NewFileModal';
import NewFolderModal from './NewFolderModal';
import StarsModal from './StarsModal';
import Preferences from './Preferences';
import ShareModal from './ShareModal';
import UploadFileModal from './UploadFileModal';
import CreateClassroomModal from './CreateClassroomModal';
import JoinClassroomModal from './JoinClassroomModal';
import AddRoleModal from './AddRoleModal';
import BrowseClassroomModal from './BrowseClassroomModal';
import ManageJoinCodeModal from './ManageJoinCodeModal';
import PublishClassroomModal from './PublishClassroomModal';

// Maps state.ide.classroomModal → its Overlay title + inner content component.
const CLASSROOM_MODALS = {
  create: {
    titleKey: 'Nav.Classroom.Create',
    titleDefault: 'Create classroom',
    Component: CreateClassroomModal
  },
  join: {
    titleKey: 'Nav.Classroom.Join',
    titleDefault: 'Join classroom',
    Component: JoinClassroomModal
  },
  role: {
    titleKey: 'Nav.Classroom.AddRole',
    titleDefault: 'Add Instructor or admin',
    Component: AddRoleModal
  },
  browse: {
    titleKey: 'Nav.Classroom.View',
    titleDefault: 'View classroom',
    Component: BrowseClassroomModal
  },
  managecode: {
    titleKey: 'Nav.Classroom.ManageCode',
    titleDefault: 'Manage join code',
    Component: ManageJoinCodeModal
  },
  publish: {
    titleKey: 'Nav.Classroom.Publish',
    titleDefault: 'Publish classroom',
    Component: PublishClassroomModal
  }
};

export default function IDEOverlays() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    modalIsVisible,
    newFolderModalVisible,
    uploadFileModalVisible,
    preferencesIsVisible,
    keyboardShortcutVisible,
    shareModalVisible,
    starsModalVisible,
    classroomModal,
    errorType
  } = useSelector((state) => state.ide);

  const classroom = classroomModal && CLASSROOM_MODALS[classroomModal];

  return (
    <>
      {preferencesIsVisible && (
        <Overlay
          title={t('Preferences.Settings')}
          ariaLabel={t('Preferences.Settings')}
          closeOverlay={() => dispatch(closePreferences())}
        >
          <Preferences />
        </Overlay>
      )}
      {location.pathname === '/feedback' && (
        <Overlay
          title={t('IDEView.SubmitFeedback')}
          ariaLabel={t('IDEView.SubmitFeedbackARIA')}
        >
          <Feedback />
        </Overlay>
      )}
      {shareModalVisible && (
        <Overlay
          title={t('IDEView.ShareTitle')}
          ariaLabel={t('IDEView.ShareARIA')}
          closeOverlay={() => dispatch(closeShareModal())}
        >
          <ShareModal />
        </Overlay>
      )}
      {keyboardShortcutVisible && (
        <Overlay
          title={t('KeyboardShortcuts.Title')}
          ariaLabel={t('KeyboardShortcuts.Title')}
          closeOverlay={() => dispatch(closeKeyboardShortcutModal())}
        >
          <KeyboardShortcutModal />
        </Overlay>
      )}
      {errorType && (
        <Overlay
          title={t('Common.Error')}
          ariaLabel={t('Common.ErrorARIA')}
          closeOverlay={() => dispatch(hideErrorModal())}
        >
          <ErrorModal
            type={errorType}
            closeModal={() => dispatch(hideErrorModal())}
          />
        </Overlay>
      )}
      {classroom && (
        <Overlay
          title={t(classroom.titleKey, {
            defaultValue: classroom.titleDefault
          })}
          ariaLabel={t(classroom.titleKey, {
            defaultValue: classroom.titleDefault
          })}
          closeOverlay={() => dispatch(closeClassroomModal())}
        >
          <classroom.Component />
        </Overlay>
      )}
      {modalIsVisible && <NewFileModal />}
      {starsModalVisible && <StarsModal />}
      {newFolderModalVisible && <NewFolderModal />}
      {uploadFileModalVisible && <UploadFileModal />}
    </>
  );
}
